import React, { useState, useEffect ,Suspense} from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import { getApi } from '../../../Services/apiService';
// import EditUserModal from './editUser';
import DeleteModal from '../../SharedComponents/deleteModal';



const Support = () => {

  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [filterQuery, setFilterQuery] = useState('');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editUserModal, setEditUserModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null); // New state for storing selected user ID


  // Function to fetch users
  const fetchUsers = async () => {
	if(query==''){
    setLoading(true);
	}
    setError(null);

    try {
      const response = await getApi(
        `/admin/users?search=${query}&per_page=50`
      );
      if (response && response.statusCode === 200) {
        setUsers(response?.data || []);
      } else {
        throw new Error('Failed to fetch users.');
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // fetchUsers();
  }, [query,editUserModal,deleteModal]); // Fetch users on component mount

  // Handle search input change
  const handleSearchChange = (event) => {
    setQuery(event.target.value);
    // fetchUsers();  // Trigger the search immediately after keyup
  };
  const openModal = (selectedUser) => {
    setSelectedUserId(selectedUser); // Store the selected user ID
    setEditUserModal(true);
};
const openDeleteUserModal = (id) => {
  setSelectedUserId(id); // Store the selected user ID
  setDeleteModal(true);  // Open the delete modal
};

  return (
    <div className='RightSideDiv'>
       
    <div className='row'>
      <div className='col-sm-12'>
 
        {/*------------------------------------------------------- role & permission start---------------------------------------- */}
        <div className='setting-right setting-right-table'>
          <h3>Role & Permissions</h3>
          <div class="table-header">
          <div class="search-card">
            <img  src={window.getPublicUrl('/assets/images/search-icon.svg')} alt=""/>
            <input type="text" class="search-input" placeholder="Search Shipping Method..."/>
          </div>
            <div class="table-actions">
                <button class="btn"><img src={window.getPublicUrl('/assets/images/import.png')} alt=""/>Import</button>
                <button class="btn"><img src={window.getPublicUrl('/assets/images/export.svg')} alt=""/>Export</button>
                <button class="btn add">+ Add New Method</button>
            </div>
        </div>
        <div className='permission-table-inner'>
          <table class="custom-table table-striped ">
            <thead>
                <tr>
                    <th class="checkbox"><label class="checbox-cs">
                        <input type="checkbox" />
                        <span class="checkmark"></span>
                      </label></th>
                    <th class="code">Code</th>
                    <th class="name">Name</th>
                    <th class="action">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="checkbox"><label class="container"/>
                        <input type="checkbox" />
                        <span class="checkmark"></span></td>
                    <td class="code">001</td>
                    <td class="name">Air</td>
                    <td class="action">
                        <div class="dropdown">
                            <button class="dropbtn action-text">Actions <img  src={window.getPublicUrl('/assets/images/action-drops.png')} alt=""/>  </button>
                            <div class="dropdown-content">
                                <a href="#">Edit</a>
                                <a href="#">Delete</a>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="checkbox"><label class="container"/>
                        <input type="checkbox" />
                        <span class="checkmark"></span></td>
                    <td class="code">001</td>
                    <td class="name">Air</td>
                    <td class="action">
                        <div class="dropdown">
                            <button class="dropbtn action-text">Actions <img  src={window.getPublicUrl('/assets/images/action-drops.png')} alt=""/> </button>
                            <div class="dropdown-content">
                                <a href="#">Edit</a>
                                <a href="#">Delete</a>
                            </div>
                        </div>
                    </td>
                </tr>    <tr>
                    <td class="checkbox"><label class="container"/>
                        <input type="checkbox" />
                        <span class="checkmark"></span></td>
                    <td class="code">001</td>
                    <td class="name">Air</td>
                    <td class="action">
                        <div class="dropdown">
                            <button class="dropbtn action-text">Actions <img  src={window.getPublicUrl('/assets/images/action-drops.png')} alt=""/> </button>
                            <div class="dropdown-content">
                                <a href="#">Edit</a>
                                <a href="#">Delete</a>
                            </div>
                        </div>
                    </td>
                </tr>    <tr>
                    <td class="checkbox"><label class="container"/>
                        <input type="checkbox" />
                        <span class="checkmark"></span></td>
                    <td class="code">001</td>
                    <td class="name">Air</td>
                    <td class="action">
                        <div class="dropdown">
                            <button class="dropbtn action-text">Actions <img  src={window.getPublicUrl('/assets/images/action-drops.png')} alt=""/>  </button>
                            <div class="dropdown-content">
                                <a href="#">Edit</a>
                                <a href="#">Delete</a>
                            </div>
                        </div>
                    </td>
                </tr>

</tbody>
 
        </table>
        </div>
        </div>



      </div>
    </div>


      {loading && <p>Loading...</p>}
      {/* {error && <p className="error-message">{error}</p>} */}







      

                <Suspense fallback={<div>Loading...</div>}>

                <Modal isOpen={deleteModal} onRequestClose={() => setDeleteModal(false)} contentLabel="Delete Modal" shouldCloseOnOverlayClick={false} ariaHideApp={false}
                    overlayClassName={`modal-overlay add-category delete logout `}
                    portalClassName="add-user delete">
                    <DeleteModal setDeleteModal={setDeleteModal}  userDetails ={selectedUserId} title={'this user'} comp={'user'}/>
                </Modal>
                </Suspense>
    </div>
    
  );
};


export default Support;